import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type { ChargesListResponse } from "@ServerTypes/estimates/estimates.schema";

export async function getChargesList(data = {}) {
  const response = await axiosWrapper.post<ChargesListResponse>(`${getBackendUrl()}/estimate/chargesList`, data);
  return response;
}

// Create (no _id) or update (with _id) a charge via its dedicated endpoint. The former
// /chargesList action-dispatcher has been split; the backend strips any extra fields.
export async function saveCharge(value: { _id?: string; name: string; percentage: number }) {
  const path = value._id ? "/estimate/updateCharge" : "/estimate/createCharge";
  const response = await axiosWrapper.post<ChargesListResponse>(`${getBackendUrl()}${path}`, value);
  return response;
}

export async function deleteCharges(keys: string[]) {
  const response = await axiosWrapper.post<ChargesListResponse>(`${getBackendUrl()}/estimate/deleteCharge`, { keys });
  return response;
}
